import {
  upsellArrayHasDisplayableCharts,
  upsellArrayHasHype,
} from '~/helpers/ProductUpsell'

import { UpsellNames, UpsellStatusNames } from '~/enums/Product'

import type { UpsellStatusDescriptor } from '~/types/Product'

export function useTrackUpsells(
  trackUpsells: MaybeRefOrGetter<UpsellStatusDescriptor[]>,
) {
  const hasChartsUpsell = computed(() =>
    upsellArrayHasDisplayableCharts(toValue(trackUpsells)),
  )
  const hasHypeUpsell = computed(() =>
    upsellArrayHasHype(toValue(trackUpsells)),
  )
  const wasHypePurchasedWithGrooverPlus = computed(() => {
    return toValue(trackUpsells).some(
      (upsell) =>
        upsell.status === UpsellStatusNames.GROOVER_PLUS &&
        upsell.upsell.name === UpsellNames.HYPE,
    )
  })
  const wasChartsPurchasedWithGrooverPlus = computed(() => {
    return toValue(trackUpsells).some(
      (upsell) =>
        upsell.status === UpsellStatusNames.GROOVER_PLUS &&
        upsell.upsell.name === UpsellNames.CHARTS,
    )
  })

  return {
    hasChartsUpsell,
    hasHypeUpsell,
    wasHypePurchasedWithGrooverPlus,
    wasChartsPurchasedWithGrooverPlus,
  }
}
